module.exports = __webpack_public_path__ + "assets/img/left.c287042a.svg";